import { render, staticRenderFns } from "./hot-data.vue?vue&type=template&id=50825a60&scoped=true&"
import script from "./hot-data.vue?vue&type=script&lang=js&"
export * from "./hot-data.vue?vue&type=script&lang=js&"
import style0 from "./hot-data.vue?vue&type=style&index=0&id=50825a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50825a60",
  null
  
)

export default component.exports